import { render, staticRenderFns } from "./Basics.vue?vue&type=template&id=788be8d4"
import script from "./Basics.vue?vue&type=script&lang=js"
export * from "./Basics.vue?vue&type=script&lang=js"
import style0 from "./Basics.vue?vue&type=style&index=0&id=788be8d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports